module.exports = __webpack_public_path__ + "static/media/favicon.377bf97a.ico";